<div class="modal-header">
  <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss()">
    Close
  </button>
  <h4 class="modal-title text-center" id="modal-title">
    {{ resolvedTitle() ? resolvedTitle() : 'Confirm Action' }}
  </h4>
</div>
<div class="modal-body">
  <h3>{{ resolvedText() ? resolvedText() : 'Are you sure you want to perform this action?' }}</h3>
  <div class="form-group mt-3">
    <label for="typed-confirm-required-text">Type "{{ resolvedRequiredText() }}" to confirm</label>
    <input
      id="typed-confirm-required-text"
      type="text"
      class="form-control"
      [(ngModel)]="confirmationText"
      autocomplete="off"
    />
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-yellow w-132" [disabled]="!canConfirm()" (click)="confirm()">
    Confirm
  </button>
  <button type="button" class="btn btn-danger w-132" (click)="modal.dismiss()">Cancel</button>
</div>
